import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { typography } from '../../../styles/typography';

export const bannerTopCss = css`
  padding: 8px 40px;
  background-color: ${colorsPalette.grey};
`;

export const bannerTopLinkCss = css`
  position: relative;
  color: #fff;
  ${typography.effra18};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const bannerTopLinkIconCss = css`
  display: inline-block;
  margin: 2px 0 0 2px;
  line-height: 1;
  vertical-align: middle;
`;
